// VerticalSlider.jsx
import React, { useState, useEffect } from 'react';
import MuiSlider from '@mui/material/Slider';
import './slider_vertical.css';

// Sentinela para infinito en el UI del slider
const SLIDER_INFINITY = 460;

// Mapea valores del slider -> claves FL_MAP
const valueToKey = {
  0: 'Surface',
  25: 'Above FL25',
  50: 'Above FL50',
  75: 'Above FL75',
  100: 'Above FL100',
  125: 'Above FL125',
  150: 'Above FL150',
  175: 'Above FL175',
  200: 'Above FL200',
  225: 'Above FL225',
  250: 'Above FL250',
  275: 'Above FL275',
  300: 'Above FL300',
  325: 'Above FL325',
  350: 'Above FL350',
  375: 'Above FL375',
  400: 'Above FL400',
  425: 'Above FL425',
  450: 'Above FL450',
  [SLIDER_INFINITY]: 'Above ∞'
};

// Para mostrar etiquetas (no cambies FL_MAP)
const formatLabel = (key) => {
  if (key === 'Surface') return 'Surface';
  if (key === 'Above ∞') return 'Above ∞';
  // "Above FLxxx" -> "Above FLxxx"
  return key;
};

// cache opcional si quieres persistir entre montajes
let sliderRangeCache = [0, SLIDER_INFINITY];

function VerticalSlider({ selectedCategory, setSelectedCategory }) {
  const [sliderRange, setSliderRange] = useState(sliderRangeCache);

  // Mantén el UI sincronizado si selectedCategory cambia desde fuera
  useEffect(() => {
    const keyToValue = (key) => {
      const entry = Object.entries(valueToKey)
        .find(([, k]) => k === key);
      return entry ? Number(entry[0]) : 0;
    };
    const uiRange = [ keyToValue(selectedCategory[0]), keyToValue(selectedCategory[1]) ];
    setSliderRange(uiRange);
    sliderRangeCache = uiRange;
  }, [selectedCategory]);

  const handleSliderChange = (_event, newValue) => {
    setSliderRange(newValue);
    sliderRangeCache = [...newValue];
    // Mapea valores del slider a las claves esperadas por ViewMap (FL_MAP)
    const newKeys = newValue.map(v => valueToKey[v] ?? (v === 0 ? 'Surface' : `Above FL${v}`));
    setSelectedCategory(newKeys);
  };

  return (
    <div className="cql-control">
      <MuiSlider
        orientation="vertical"
        min={0}
        max={SLIDER_INFINITY}
        step={null}                  // solo paradas en 'marks'
        value={sliderRange}
        onChange={handleSliderChange}
        disableSwap
        marks={Object.keys(valueToKey).map(v => ({ value: Number(v) }))}
        valueLabelDisplay="on"
        valueLabelFormat={(value, index) => {
          const key = valueToKey[value] ?? (value === 0 ? 'Surface' : `Above FL${value}`);
          const lbl = formatLabel(key);
          // Pulgar superior: mostrar "Below ..."
          return index === 1 ? lbl.replace(/^Above/, 'Below') : lbl;
        }}
        sx={{
          height: '32vh',
          '& .MuiSlider-thumb': { height: 16, width: 16, backgroundColor: '#fff', border: '2px solid #1976d2',
            '&.Mui-active, &:hover': { height: 20, width: 20 } },
          '& .MuiSlider-track': { backgroundColor: '#3498db', border: '1px solid white', opacity: 0.9 },
          '& .MuiSlider-rail': { backgroundColor: '#59c7ff' },
          '& .MuiSlider-mark': { backgroundColor: '#6b6b6b', height: 8, width: 8, borderRadius: '50%' },
          '& .MuiSlider-valueLabel': {
            lineHeight: 1.2, fontSize: '0.7rem', backgroundColor: '#1976d2', color: 'white',
            borderRadius: '6px', padding: '4px 6px', '&:before': { display: 'none' },
          },
        }}
      />
    </div>
  );
}

export default VerticalSlider;
